module.exports = __webpack_public_path__ + "img/lesson_12.8c4c5caf.jpg";